import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseRepository } from '@common/data/base';
import { ApiResources } from '@constants/api-resources';
import { environment } from '@environment/environment';
import { Observable } from 'rxjs';
import {
  GetMedicaoDto,
  PostAprovarMedicaoDto,
  PostPrintExportMedicaoDto,
  PostReprovarMedicaoDto,
} from './dto';
import { MedicaoModel, MedicaoResponse, PrintExportMedicaoModel } from './models';

//this class must be refactor
/**
 * Integração com API LW
 */
@Injectable()
export class MedicaoRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverLwUrl, ApiResources.MEDICOES);
  }

  aprovarMedicao(params: PostAprovarMedicaoDto): Observable<MedicaoModel> {
    return this.customClient
      .post(`medicoes/aprovar-medicoes`, {
        CodigosMedicoes: [params.medicaoId],
      })
      .pipe(this.mapperData());
  }

  reprovarMedicao(params: PostReprovarMedicaoDto): Observable<MedicaoModel> {
    return this.customClient
      .post(`medicoes/cancelar-medicoes`, {
        CodigoMotivoCancelamento: params.motivoCancelamento,
        CodigosMedicoes: [params.medicaoId],
        Justificativa: params.justificativa,
      })
      .pipe(this.mapperData());
  }

  imprimirExportarMedicao(params: PostPrintExportMedicaoDto): Observable<PrintExportMedicaoModel> {
    return this.customClient
      .post(`medicoes/imprimir`, {
        CodigoMedicao: params.medicaoId,
        TipoImpressao: params.tipoImpressao,
      })
      .pipe(this.mapperData());
  }
}
